const state = {
    joiningOptions: {
        classCode: undefined,
        invitationToken: undefined,
        needSales: false,
    },
    studentClasses: [],
    openAssignments: [],
    allOpenAssignments: [],
};
export default state;